import { LoadableLazy } from '@confluence/loadable';

export const PublishModal = LoadableLazy({
	loader: async () => {
		return (await import(/* webpackChunkName: "loadable-PublishModal" */ './PublishModal.tsx'))
			.PublishModal;
	},
});

export const DiscardModal = LoadableLazy({
	loader: async () => {
		return (await import(/* webpackChunkName: "loadable-DiscardModal" */ './DiscardModal.tsx'))
			.DiscardModal;
	},
});
export const CancelSchedulePublishModal = LoadableLazy({
	loader: async () => {
		return (
			await import(
				/* webpackChunkName: "loadable-CancelSchedulePublishModal" */ './CancelSchedulePublishModal.tsx'
			)
		).CancelSchedulePublishModal;
	},
});
